export default     {
    path: '/dashboard/skills',
    components: {
        default: () => import('../../views/memberDashboard/dashboard/index.vue'),
        header: () => import('../../views/memberDashboard/header/index.vue'),
        footer: () => import('../../views/public/footer/index.vue'),
    },
    children: [
        {
            path: '',
            redirect: '/dashboard/classroom/skills'
        },
    ]
}